module.exports = __webpack_public_path__ + "static/media/alert-triangle-black.b41e6438.svg";